import MainLayout from '@/layouts/MainLayout.vue';
import { PageName, UserRoles } from '@/common/constants';
import { RouteRecordRaw } from 'vue-router';
import AccessLogListPage from './pages/AccessLogListPage.vue';

const accessLogRouters: Array<RouteRecordRaw> = [
    {
        path: '/log',
        component: MainLayout,
        children: [
            {
                path: 'user',
                name: PageName.USER_LOG_LIST_PAGE,
                component: AccessLogListPage,
                meta: {
                    requiresAuth: true,
                    breadcrumb: [
                        {
                            text: 'accessLog.breadcrumb.accessLog',
                        },
                        {
                            text: 'accessLog.breadcrumb.userLog',
                            link: '/log/user',
                        },
                    ],
                    required3DViewerRoles: [UserRoles.ADMIN],
                },
            },
        ],
    },
];

export default accessLogRouters;
